import {Modal, Spin, Tag} from "antd";
import React from "react";
import {PromptPreviewEstimate, PromptPreviewMessage} from "../../service/VulSourceItemService";
import * as styles from "./PromptPreviewDrawer.module.css";

interface Props {
    messages?: PromptPreviewMessage[];
    estimate?: PromptPreviewEstimate;
    aiExtractorName?: string;
    open: boolean;
    onClose: () => void;
    loading?: boolean;
}

function PromptPreviewModal(props: Props) {
    return (
        <Modal
            title={`Prompt preview${props.aiExtractorName ? ` — ${props.aiExtractorName}` : ""}`}
            open={props.open}
            onCancel={props.onClose}
            footer={null}
            mask={{closable: false}}
            destroyOnHidden={true}
            width={"90%"}
            style={{maxWidth: 1200}}
        >
            <Spin spinning={!!props.loading}>
                {props.estimate &&
                    <div className={styles["request-estimate"]}>
                        Estimated prompt size: {formatCompactCount(props.estimate.tokens)} tokens, {formatCompactCount(props.estimate.characters)} chars
                    </div>
                }

                {props.messages?.map((msg, index) => (
                    <div key={index} className={styles["message-block"]}>
                        <div className={styles["message-header"]}>
                            <div className={styles["message-title"]}>
                                <Tag color={messageRoleColor(msg.role)}>{msg.role}</Tag>
                                <h3 className={styles["message-label"]}>{msg.label}</h3>
                            </div>
                            {msg.estimate &&
                                <Tag className={styles["message-estimate"]}>
                                    {formatCompactCount(msg.estimate.tokens)} tokens, {formatCompactCount(msg.estimate.characters)} chars
                                </Tag>
                            }
                        </div>
                        <pre className={styles["message-content"]}>{msg.content}</pre>
                    </div>
                ))}
            </Spin>
        </Modal>
    );
}

function formatCompactCount(value: number) {
    const roundedValue = Math.round(value);

    if (Math.abs(roundedValue) < 1000) {
        return String(roundedValue);
    }

    if (Math.abs(roundedValue) < 1_000_000) {
        return `${formatCompactDecimal(roundedValue / 1000)}k`;
    }

    return `${formatCompactDecimal(roundedValue / 1_000_000)}M`;
}

function formatCompactDecimal(value: number) {
    return value.toFixed(1).replace(/\.0$/, "");
}

function messageRoleColor(role: string) {
    switch (role) {
        case "system":
            return "blue";
        case "developer":
            return "cyan";
        case "schema":
            return "purple";
        default:
            return "green";
    }
}

export default PromptPreviewModal;
